'use client'

import { useState } from 'react'
import { post } from '@/services/api/axiosClient'
import { useTranslations } from '@/helpers/useTranslations'

const sendLoginGTMEvent = (data: {
    event: 'login'
    tm_status: 'success' | 'fail'
    /**the text that is shown to the user when te login attempt fails */
    tm_value: string
    /**Number of login attempts in a session */
    tm_count: string
}) => window.dataLayer.push(data)

export const UseLoginHook = () => {
    const [loginError, setLoginError] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [attemptCount, setAttemptCount] = useState<number>(0)
    const translate = useTranslations()

    const loginHandler = async (data: any) => {
        if (!data) {
            return
        }
        setAttemptCount(attemptCount + 1)
        setIsLoading(true)
        return post(`api/account/login`, data)
            .then(({ data: response }) => {
                if (response.isSuccess) {
                    sendLoginGTMEvent({
                        event: 'login',
                        tm_status: 'success',
                        tm_value: '',
                        tm_count: attemptCount.toString(),
                    })
                    setLoginError(false)
                    location.replace(response.data)
                } else {
                    sendLoginGTMEvent({
                        event: 'login',
                        tm_status: 'fail',
                        tm_value: translate('PASSWORD_DOES_NOT_MATCH'),
                        tm_count: attemptCount.toString(),
                    })
                    setLoginError(true)
                }
            })
            .catch(() => {
                setLoginError(true)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return {
        isLoading,
        loginHandler,
        loginError,
    }
}
